<div class="allergy-picto">
    <img src="/assets/pictos/allergies/{{allergy.allergyName}}.svg">
    <p>{{allergy.description}}</p>
</div>
